import { makeStyles } from 'tss-react/mui';

const useOrderProductGridMenuStyles = makeStyles()((theme) => ({
  menuItem: {
    color: theme.palette.text.primary,
  },
  menuItemContent: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useOrderProductGridMenuStyles;
